import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  contentTab: {
    margin: '10px 0 0 0',
    display: 'flex'
    // flexDirection: 'column'
  },
  activeBox: {
    marginTop: 26,
    padding: '6px 6px 8px 6px',
    transition:
      'max-height 0.3s ease-in-out, height 0.3s ease-in-out, background-color 0.3s',
    overflow: 'hidden',
    borderRadius: '8px',
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_100.main
  },
  attachmentContainer: {
    // marginTop: '-8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  attachmentInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    width: '100%'
  },
  attachmentContent: {
    position: 'relative',
    width: '100%',
    textAlign: 'center'
  },
  buttonsAttachmentFile: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    width: '100%',
    height: '80px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_100.main,
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    borderRadius: '8px',
    padding: '16px',
    flexDirection: 'column',
    textTransform: 'none'
  },
  buttonsBoxAttachment: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  buttonsAttachment: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '8px'
  },
  attachmentPreviewImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // maxWidth: 100,
    maxHeight: 90,
    padding: '8px',
    objectFit: 'contain',
    borderRadius: '8px',
    height: 'auto'
  },
  attachmentNotFile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    fontStyle: 'italic'
  },
  dialogContentPreview: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden'
  },
  imagePreview: {
    maxWidth: '100%',
    maxHeight: '50vh',
    objectFit: 'contain'
  },
  iconButtonDelete: {
    border: 0,
    padding: '0',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& svg': {
      color: theme.palette.red_100.main
    }
  }
}))
